import { responseStartGame } from "../../classes/types/class-user.types";

async function sendResetGameRequest(userId: string): Promise<responseStartGame | undefined> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}user/game/resetprogress`, {
            method: "put",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });

        const result: responseStartGame = await response.json();

        if (!result) {
            return { status: 400 };
        }

        return result;
    } catch (error) {
        console.error(error);
    }
    return;
}

export default sendResetGameRequest;
